export default "__VITE_ASSET__CdA6VocH__"